import { render, staticRenderFns } from "./VacationRegistrations.vue?vue&type=template&id=306b07af&scoped=true&"
import script from "./VacationRegistrations.vue?vue&type=script&lang=js&"
export * from "./VacationRegistrations.vue?vue&type=script&lang=js&"
import style0 from "./VacationRegistrations.vue?vue&type=style&index=0&id=306b07af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306b07af",
  null
  
)

export default component.exports